"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class BookingFeesMessage extends _react.default.Component {
  shouldWeShowMessage() {
    const {
      isHomepage,
      agent,
      noBookingFeesAgents
    } = this.props;
    if (!(agent && noBookingFeesAgents) || isHomepage) return false;
    if (noBookingFeesAgents.indexOf(agent) > -1) return true;
    return false;
  }
  render() {
    if (!this.shouldWeShowMessage()) return null;
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "nobfee"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "NO"), " booking fees or debit card charges");
  }
}
BookingFeesMessage.propTypes = {
  isHomepage: _propTypes.bool,
  agent: _propTypes.string,
  noBookingFeesAgents: _propTypes.array
};
var _default = exports.default = BookingFeesMessage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/bookingFeesMessage.js
// module id = 478
// module chunks = 119